import "react-responsive-carousel/lib/styles/carousel.min.css";

import { useState } from "react";
import { Carousel } from "react-responsive-carousel";

import { EventType } from "~/types/event/event.types";

import CannotBookPopup from "../cannotBookPopup";
import HighlightedItem from "../highlightedEvent";
import styles from "./index.module.scss";

type Props = { events: EventType[] };

const HighlightsCarousel = ({ events }: Props) => {
  const [cannotBookPopup, setCannotBookPopup] = useState(false);
  return (
    <>
      <CannotBookPopup open={cannotBookPopup} setOpen={setCannotBookPopup} />
      <Carousel className={styles.carouselContainer} showStatus={false}>
        {events.map((event) => {
          return (
            <HighlightedItem
              key={event.id}
              event={event}
              setCannotBookPopup={setCannotBookPopup}
            />
          );
        })}
      </Carousel>
    </>
  );
};

export default HighlightsCarousel;
